import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";

const ShopPopup = ({ show, close, details }) => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [variantList, setVariantList] = useState([]);

  useEffect(() => {
    try {
      (async () => {
        form.setFieldsValue({
          name: details.name,
          variant: details && details.Variant.id,
        });
        const data = await axios.get("/variant-list-all").catch((error) => {
          Helper.ErrorHanlder(error);
        });
        if (data && data.data) setVariantList(data.data.data);
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
    // eslint-disable-next-line
  }, []);

  const handleOk = async () => {
    try {
      let formValues = form.getFieldsValue();
      let obj = {
        id: details.id,
        variantId: formValues.variant,
        name: formValues.name,
      };
      if (obj.name && obj.variantId) {
        const data = await axios
          .post("/attribute-create", obj)
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) close(data);
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <>
      <Modal
        title={details ? "Update Shop Details" : "Create New Shop"}
        open={show}
        onCancel={handleCancel}
        footer={false}
      >
        <Form
          layout={"vertical"}
          form={form}
          size={"small"}
          labelCol={{
            span: 6,
          }}
          style={{
            marginTop: 30,
          }}
        >
          <Form.Item
            label="Varient"
            name="variant"
            rules={[
              {
                required: true,
                message: "Varient is required",
              },
            ]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {variantList.map((i) => (
                <Option key={i.id} value={i.id}>
                  {i.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Attribute"
            name="name"
            rules={[
              {
                required: true,
                message: "Attribute is required",
              },
            ]}
          >
            <Input placeholder="input placeholder" />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
              onClick={handleOk}
            >
              {details.id ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ShopPopup;
